import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid place-items-center items-center md:h-screen mt-5 md:mt-0" }
const _hoisted_2 = { class: "col-span-12 md:col-span-5 md:w-5/12" }
const _hoisted_3 = { class: "bg-white shadow-md rounded-xl overflow-hidden lg:m-10" }
const _hoisted_4 = { class: "bg-gray-50 p-5" }
const _hoisted_5 = { class: "text-2xl font-medium mb-3" }
const _hoisted_6 = { class: "px-5 py-3" }
const _hoisted_7 = { class: "flex flex-col my-4" }
const _hoisted_8 = { class: "flex flex-col my-4" }
const _hoisted_9 = { class: "bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Nova senha",
                en: "New password",
              })), 1)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendEmail()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InputPassword, {
                id: "password-input",
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event)),
                feedback: false,
                toggleMask: "",
                placeholder: "Senha",
                class: _normalizeClass(_ctx.v$.form.password.$error ? 'p-invalid' : '')
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.password.$errors
              }, null, 8, ["errors"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_InputPassword, {
                id: "confirm-password-input",
                modelValue: _ctx.form.confirmPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                feedback: false,
                toggleMask: "",
                placeholder: "Confirmar senha",
                class: _normalizeClass(_ctx.v$.form.confirmPassword.$error ? 'p-invalid' : '')
              }, null, 8, ["modelValue", "class"]),
              _createVNode(_component_Errors, {
                errors: _ctx.v$.form.confirmPassword.$errors
              }, null, 8, ["errors"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Button, {
              type: "button",
              label: "Retornar ao login",
              class: "btn-simple",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go.redirectTo('sign-in')))
            }),
            _createVNode(_component_Button, {
              type: "submit",
              label: "Enviar",
              class: "btn-primary",
              loading: _ctx.loading
            }, null, 8, ["loading"])
          ])
        ], 32)
      ])
    ])
  ]))
}